import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Gallery, GalleryItem, ImageItem } from 'ng-gallery';
import { Lightbox } from 'ng-gallery/lightbox';

@Component({
  selector: 'app-feature-details',
  imports: [RouterModule],
  templateUrl: './feature-details.html',
  styleUrl: './feature-details.scss',
})
export class FeatureDetails {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly gallery = inject(Gallery);
  private readonly lightbox = inject(Lightbox);

  // Unique id so this gallery's lightbox doesn't collide with other galleries on the page
  private readonly galleryId = 'feature-details-lightbox';

  environment = environment;
  feature = environment.FeatureConfig;
  booking: any = environment.BookingConfig;

  card = this.feature.cards[0];
  title = this.feature;

  images: any[] = [];

  selectedIndex = 0;


  // =========================================================
  // CONSTRUCTOR
  // =========================================================

  constructor() {

    const id = this.route.snapshot.paramMap.get('id');

    if (!id) {
      this.router.navigate(['/']);
      return;
    }

    const selected = (this.feature.cards as any[]).find(
      card => card.id === id
    );

    if (!selected) {
      this.router.navigate(['/']);
      return;
    }

    this.card = selected;
    this.images = (this.card.images ?? []) as any[];

    // Create gallery items
    const items: GalleryItem[] = this.images.map(image => {
      return new ImageItem({
        src: image.srcUrl,
        thumb: image.previewUrl,
        alt: image.alt,
      });
    });

    // 'contain' + disabled autoHeight keeps every image fully visible within the fixed lightbox frame
    this.gallery.ref(this.galleryId, { imageSize: 'contain', thumbPosition: 'bottom', autoHeight: false }).load(items);
  }

  open(index: number): void {
    this.lightbox.open(index, this.galleryId);
  }

  select(index: number): void {
    this.selectedIndex = index;
  }

  prev(): void {
    this.selectedIndex = (this.selectedIndex - 1 + this.images.length) % this.images.length;
  }

  next(): void {
    this.selectedIndex = (this.selectedIndex + 1) % this.images.length;
  }

}
